"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CigaretteProvider = CigaretteProvider;
exports.update = exports.resetSteps = exports.backStep = exports.addStep = void 0;
exports.useCigarette = useCigarette;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ActionType = {
  BACK_STEP: 'backStep',
  ADD_STEP: 'addStep',
  RESET_STEPS: 'resetSteps',
  UPDATE: 'update'
};
var CigaretteStateContext = /*#__PURE__*/(0, _react.createContext)(undefined);

var addStep = function addStep(payload) {
  return {
    type: ActionType.ADD_STEP,
    payload: payload
  };
};

exports.addStep = addStep;

var backStep = function backStep() {
  return {
    type: ActionType.BACK_STEP
  };
};

exports.backStep = backStep;

var resetSteps = function resetSteps() {
  return {
    type: ActionType.RESET_STEPS
  };
};

exports.resetSteps = resetSteps;

var update = function update(payload) {
  return {
    type: ActionType.UPDATE,
    payload: payload
  };
};

exports.update = update;

function cigaretteReducer(state, action) {
  switch (action.type) {
    case ActionType.BACK_STEP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          steps: _toConsumableArray(state.steps.slice(0, state.steps.length - 1))
        });
      }

    case ActionType.ADD_STEP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          steps: [].concat(_toConsumableArray(state.steps), [action.payload])
        });
      }

    case ActionType.RESET_STEPS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          steps: []
        });
      }

    case ActionType.UPDATE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isMobile: action.payload.isMobile,
          isWizard: action.payload.isWizard
        });
      }

    default:
      {
        return state;
      }
  }
}

function CigaretteProvider(_ref) {
  var children = _ref.children,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$isWizard = _ref.isWizard,
      isWizard = _ref$isWizard === void 0 ? false : _ref$isWizard,
      setIsWizardOpen = _ref.setIsWizardOpen,
      initialOpenedField = _ref.initialOpenedField;

  var _useReducer = (0, _react.useReducer)(cigaretteReducer, {
    steps: [],
    isMobile: isMobile,
    isWizard: isWizard
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var value = {
    state: state,
    dispatch: dispatch
  };
  (0, _react.useEffect)(function () {
    dispatch(update({
      isMobile: isMobile,
      isWizard: isWizard
    }));
  }, [isMobile, isWizard]);
  (0, _react.useEffect)(function () {
    if (!setIsWizardOpen) return;

    if ((0, _isEmpty2["default"])(state === null || state === void 0 ? void 0 : state.steps)) {
      setIsWizardOpen(false);
    }

    if ((0, _utils.afterDestinationStep)(state === null || state === void 0 ? void 0 : state.steps)) {
      setIsWizardOpen(true);
    }
  }, [state === null || state === void 0 ? void 0 : state.steps, setIsWizardOpen]);
  (0, _react.useEffect)(function () {
    if (!isWizard || !initialOpenedField) return;
    dispatch(addStep(initialOpenedField));
  }, [initialOpenedField, isWizard]);
  return /*#__PURE__*/_react["default"].createElement(CigaretteStateContext.Provider, {
    value: value
  }, children);
}

function useCigarette() {
  var context = (0, _react.useContext)(CigaretteStateContext);

  if (context === undefined) {
    throw new Error('useCigarette must be used within a CigaretteProvider');
  }

  return context;
}